<template>
  <div>
    <div id="header">
      <som-header app-name="OK2SAY Confidential Tip Form" department-name="" main-content-id="main-content" breakpoint="md">
        <som-menu breakpoint="md">
          <som-menu-item>
            <a class="btn btn-secondary text-white font-weight-bold mr-3" href="https://www.google.com">QUICK EXIT</a>
          </som-menu-item>
          <som-menu-item>
            <a href="https://www.michigan.gov/ok2say" target="_blank">OK2SAY WEBSITE</a>
          </som-menu-item>
          <som-menu-item>
            <a href="https://www.michigan.gov/ok2say/student-resources" target="_blank">STUDENT RESOURCES</a>
          </som-menu-item>
        </som-menu>
      </som-header>
    </div>
    <div>
      <div id="main-content" class="fill-content" role="main">
        <tip-form />
      </div>
      <som-footer light></som-footer>
    </div>
  </div>
</template>

<script>
import Form from './components/Form.vue'

export default {
  name: 'app',
  components: {
    TipForm: Form
  }
}
</script>

<style>
html, body {
  background-color: rgb(247, 247, 247);
}

#header {
  position: relative;
}

.fill-content {
  min-height: calc(100vh - 3rem);
  padding-top: 0;
}

@media (min-width: 768px) {
  #header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1030;
  }

  .fill-content {
    padding-top: 4.25rem;
  }
}

</style>
